/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceDiscrepancyRemoveRequest } from '../../models/voice-discrepancy-remove-request';

export interface RemoveVoiceSessionDiscrepancy$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
      body: VoiceDiscrepancyRemoveRequest
}

export function removeVoiceSessionDiscrepancy(http: HttpClient, rootUrl: string, params: RemoveVoiceSessionDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeVoiceSessionDiscrepancy.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeVoiceSessionDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/discrepancies/remove';
